var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            "dialog-class": "email-conversation-modal",
            "hide-footer": "",
            title: "",
            visible: _vm.show && _vm.conversationId !== null,
          },
          on: {
            hidden: function ($event) {
              return _vm.$emit("hidden")
            },
          },
        },
        [
          _vm.conversationId !== null
            ? _c("csp-digital-mailbox-email-list-table", {
                attrs: {
                  "items-ajax-url": _vm.itemsAjaxUrl,
                  "table-headline": "E-Mail-Konversation",
                },
                on: { "row-clicked": _vm.onRowClicked },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(actions)",
                      fn: function ({ data }) {
                        return [
                          _c("div", { staticClass: "table-actions" }, [
                            data.actions.attachmentCount
                              ? _c(
                                  "a",
                                  {
                                    attrs: { title: "Anhänge anzeigen" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openAttachmentModal(
                                          data.actions.emailId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "inticon-autoclaim_files",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  281697658
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("csp-email-attachment-modal", {
        attrs: {
          "email-id": _vm.attachmentModalEmailId,
          show: _vm.showAttachmentModal,
        },
        on: { hidden: _vm.onAttachmentModalHidden },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }